import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const onTerminalnumSendCommand = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/onterminalnumsendcommand/' + params.terminalnum + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const sendCommand = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/sendcommand/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const sendCommandAfter2019 = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/sendcommandafter2019/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setupRegistration = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setupregistration/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const restart = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/restart/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setupMileage = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setupmileage/' + params.id + '/' + params.mileage + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setupReportInterval = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setupreportinterval/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchSetupReportInterval = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/batchsetupreportinterval' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchSendCmd = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/batchsendcmd' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const jt1078ReqRealtimeAVTrans = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/jt1078reqrealtimeavtrans/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const jt1078CtrlRealtimeAVTrans = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/jt1078ctrlrealtimeavtrans/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const dataDownlinkTransmission = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/datadownlinktransmission/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const queryTerminalAttribute = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/queryterminalattribute/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setMaxSpeed = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setmaxspeed' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchSetMaxSpeed = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/batchsetmaxspeed' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setOverSpeedDuration = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setoverspeedduration' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchSetOverSpeedDuration = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/batchsetoverspeedduration' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setContinueDriveLimit = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setcontinuedrivelimit' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchSetContinueDriveLimit = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/batchsetcontinuedrivelimit' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setContinueDriveLimitPerDay = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setcontinuedrivelimitperday' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchSetContinueDriveLimitPerDay = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/batchsetcontinuedrivelimitperday' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setMinRestingTime = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setminrestingtime' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchSetMinRestingTime = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/batchsetminrestingtime' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setMaxStopTime = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setmaxstoptime' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchSetMaxStopTime = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/batchsetmaxstoptime' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setOverSpeedAlarmDifference = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setoverspeedalarmdifference' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchSetOverSpeedAlarmDifference = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/batchsetoverspeedalarmdifference' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setFatigueDrivingAlarmDifference = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setfatiguedrivingalarmdifference' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const batchSetFatigueDrivingAlarmDifference = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/batchsetfatiguedrivingalarmdifference' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const setAcquisitionCommand = (params, urlParams) => {
  return axios.request({
    url: '/ddm/jt808/netcommand/setacquisitioncommand/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

